<div class="content pl-2">

  <div class="columns">
    <div class="column is-full">
      <div class="title">{{ 'claimsOverview.title' | localize }}
        <app-year-selector class="subtitle is-6"/>
      </div>
      <p class="subtitle is-6">{{ 'claimsOverview.subtitle' | localize }}</p>
    </div>
  </div>

  @if (isLoading) {
    <div class="columns">
      <div class="column is-12">
        <mat-spinner></mat-spinner>
        <br/>
        {{ 'common.loading' | localize }}
      </div>
    </div>
  } @else {
    <div class="columns">
      <div class="column is-full">
        <app-claim-overview-statistics [claims]="(claimList)"/>
      </div>
    </div>
    <div class="columns">
      <div class="column is-full">
        <app-claim-list [claims]="(claimList)" (onPageChange)="onPageChange($event)"/>
      </div>
    </div>
  }
</div>
